import { createContext, useContext } from 'react';

const RenewPurchaseContext = createContext();

RenewPurchaseContext.displayName = 'RenewPurchaseContext';

const useRenewPurchase = () => useContext(RenewPurchaseContext);

export { useRenewPurchase, RenewPurchaseContext };
